import { render, staticRenderFns } from "./StandWithIsraelFooter.vue?vue&type=template&id=72324f3c"
import script from "./StandWithIsraelFooter.vue?vue&type=script&lang=js"
export * from "./StandWithIsraelFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports